"use client";
import * as React from "react";
const SvgFileUploadSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M.5 6.59h3.71v5.65H9.8V6.58h3.71L7 0zm0 7.53V16h13v-1.88z" }));
export {
  SvgFileUploadSharp as default
};
